export const createTestToneUrl = () => {
  const sampleRate = 44100;
  const duration = 1.8;
  const totalSamples = Math.floor(sampleRate * duration);
  const fadeSamples = Math.floor(sampleRate * 0.03);
  const pcmData = new Int16Array(totalSamples);

  for (let index = 0; index < totalSamples; index += 1) {
    const time = index / sampleRate;
    const envelope = Math.sin(Math.PI * Math.min(1, time / duration));
    const phrase =
      0.45 * Math.sin(2 * Math.PI * 440 * time) +
      0.25 * Math.sin(2 * Math.PI * 554.37 * time) +
      0.2 * Math.sin(2 * Math.PI * 659.25 * time);

    let sample = phrase * envelope;

    if (index < fadeSamples) {
      sample *= index / fadeSamples;
    }

    if (index > totalSamples - fadeSamples) {
      sample *= (totalSamples - index) / fadeSamples;
    }

    pcmData[index] = Math.max(-1, Math.min(1, sample)) * 32767;
  }

  const buffer = new ArrayBuffer(44 + pcmData.length * 2);
  const view = new DataView(buffer);

  const writeString = (offset, value) => {
    for (let index = 0; index < value.length; index += 1) {
      view.setUint8(offset + index, value.charCodeAt(index));
    }
  };

  writeString(0, "RIFF");
  view.setUint32(4, 36 + pcmData.length * 2, true);
  writeString(8, "WAVE");
  writeString(12, "fmt ");
  view.setUint32(16, 16, true);
  view.setUint16(20, 1, true);
  view.setUint16(22, 1, true);
  view.setUint32(24, sampleRate, true);
  view.setUint32(28, sampleRate * 2, true);
  view.setUint16(32, 2, true);
  view.setUint16(34, 16, true);
  writeString(36, "data");
  view.setUint32(40, pcmData.length * 2, true);

  pcmData.forEach((sample, index) => {
    view.setInt16(44 + index * 2, sample, true);
  });

  return URL.createObjectURL(new Blob([buffer], { type: "audio/wav" }));
};
